<template>
  <div>
    <b-card-text class="p-0 scroll-bar-pop card-tab">
      <div class="row pr-3 py-2">
        <div class="col-6 col-lg-7 col-xl-9">
          <h3 v-html="stepTitle" class="cursor-pointer d-flex align-items-center" @click="checkStep()"></h3>
        </div>
        <div class="col-6 col-lg-5 col-xl-3 text-right" v-if="this.$USER_LOGIN.get().isAdmin">
          <router-link :to="`/categoryservice`">
            <b-button variant="primary" size="sm" :class="showCart !== 'non-slide' ? 'mr-4' : ''">
              <i class="fas fa-plus"></i>
              เพิ่มบริการเสริม
            </b-button>
          </router-link>
        </div>
      </div>
      <div class="row pr-3" v-if="['FIRST'].includes(tmpService.step)">
        <template v-for="category in (tmpService.categoryCode) ? totalService[tmpService.categoryCode] : categoryService">
          <div class="col-12 col-lg-6 col-xl-3 mb-3" :key="category.id">
            <CardProduct
                :product="{
                            title: category.categoryName,
                            image: category.icon,
                            type: category.type
                        }"
                :class="{disabled:idOrder}"
                @click.native="(tmpService.categoryCode) ? selectServiceDetails(category) : selectCategoryService(category) "
            />
          </div>
        </template>
      </div>
      <TabService
          v-if="['SERVICE'].includes(tmpService.step)"
          :totalService="totalService"
          :tmpService="tmpService"
          @fnGetPosRecentlyList="fnGetPosRecentlyList()"
      />
      <div class="row pr-3" v-if="serviceList.length > 0 && ['CATEGORY'].includes(tmpService.step)">
        <template v-for="category in serviceList">
          <div class="col-12 col-lg-6 col-xl-3 mb-3" :key="category.id">
            <CardProduct
                :product="{
                            title: category.serviceName,
                            image: category.icon,
                            type: category.type
                        }"
                :class="{disabled:idOrder}"
                @click.native="(tmpService.categoryCode) ? selectServiceDetails(category) : selectCategoryService(category) "
            />
          </div>
        </template>
      </div>
      <template v-if="['FIRST'].includes(tmpService.step)">
        <hr class="my-5"/>
        <div class="row pr-3">
          <div class="col-xl-3 col-md-6 col-lg-6 mb-3" >
          <!--      cunstom service      -->
            <CardPos
                :courier="{
                        title:'บริการเสริมอื่นๆ',
                        name:'อื่นๆ',
                        icon:defaultIcon,
                        type:'service'
                    }"
                :type="type"
                :class="{disabled:idOrder}"
                @click.native="$emit('openModalService')"
            />
          </div>
<!--          <div-->
<!--              class="col-xl-3 col-md-6 col-lg-6 mb-3"-->
<!--              v-if="false && $USER_LOGIN.get().isUnderByShippop">-->
<!--            <CardPos-->
<!--                :courier="{-->
<!--                            title:'ประกัน COVID-19',-->
<!--                            name:'ประกัน',-->
<!--                            icon:'Casualties_AdminShippop.png'-->
<!--                        }"-->
<!--                :class="{disabled:true}"-->
<!--                @click.native="insuranceService.show = true"-->
<!--            />-->
<!--          </div>-->
<!--          <div-->
<!--              class="col-xl-3 col-md-6 col-lg-6 mb-3"-->
<!--              v-if="permission.interParcelService" >-->
<!--            <CardPos-->
<!--                :courier="{-->
<!--                            title:'ส่งพัสดุไปต่างประเทศ',-->
<!--                            name:'พัสดุต่างประเทศ',-->
<!--                            icon:'icon-inter-parcel.png',-->
<!--                            type:'service'-->
<!--                        }"-->
<!--                :class="{disabled:idOrder}"-->
<!--                @click.native="$emit('openModal' ,'INTER_PARCEL', false)"-->
<!--            />-->
<!--          </div>-->
<!--          <div-->
<!--              v-if="false && $USER_LOGIN.get().isUnderByShippop"-->
<!--              class="col-xl-3 col-md-6 col-lg-6 mb-3"-->
<!--          >-->
<!--            <CardPos-->
<!--                :courier="{-->
<!--                            title:'เส้นด้าย - Zendai',-->
<!--                            name:'เส้นด้าย',-->
<!--                            icon:'Zendai.png',-->
<!--                        }"-->
<!--                :class="{disabled:idOrder}"-->
<!--                @click.native="zendai.show = true"-->
<!--            />-->
<!--          </div>-->
        </div>
      </template>
    </b-card-text>
  </div>
</template>

<script>
import categoryService from '@/plugins/categoryService.js'
import { totalService } from '@/plugins/service.js'
import CardProduct from "@/components/CardProduct";
import CardPos from "@/components/CardPos";
import TabService from '@/components/custom/pos/TabService'
import {
  getListCategoryService , //获取快递公司列表信息
  getListCategoryDetails } from "@/axios/service.js";
import {expressList} from "@/api/express"
import {additionalServiceCategoryList, additionalServiceList} from "@/api/additionalServices";

export default {
  props:{
    showCart: String,
    cart: Array,
    idOrder: [String, Number],
    tmpService: Object,
    addService: Function,
    insuranceService: Object,
    zendai: Object,
    permission: Object
  },
  components:{
    CardProduct,
    CardPos,
    TabService
  },
  data(){
    return{
      categoryService: categoryService,
      totalService: totalService,
      type:'Service',
      defaultIcon:require('../../../assets/images/service/ShopReceipt_AdminShippop.jpg'),
      serviceList:[],
      activeService:{}
    }
  },
  mounted(){
    this.getApiCategoryService()
  },
  methods:{
    getApiCategoryService(){
      additionalServiceCategoryList({
        pageIndex: 1,
        pageSize: 100,
      }).then( res => {
        console.log(res)
        res.data.records.forEach( item => {
            item.code = `CODE_${item.id}`
        })
        this.categoryService = [...res.data.records ];
        console.log(this.categoryService)
        this.getApiServiceDetail()
      })
    },
    getApiServiceDetail(){
      additionalServiceList(
          {
            categoryId: this.tmpService.categoryCode,
            pageIndex: 1,
            pageSize: 100,
          }
      )
          .then((res) => {
            console.log(res)
            this.serviceList = res.data.records
            this.totalService = res.data.records
          })
    },
    selectCategoryService( category ){
      this.tmpService.categoryCode = category.id
      this.tmpService.categoryName = category.categoryName
      this.nextStep('CATEGORY')
    },
    selectServiceDetails( service ){
      console.log(service)
      this.tmpService.code = service.id
      this.tmpService.name = service.serviceName
      this.tmpService.fee = (service.serviceFee > 0) ? service.serviceFee : ''
      this.nextStep('SERVICE')
    },
    checkStep(){
      if( this.tmpService.step == 'CATEGORY' ){
        this.nextStep('FIRST')
        this.tmpService.categoryCode = ''
        this.tmpService.categoryName = ''
      }else if( this.tmpService.step == 'SERVICE' ){
        this.nextStep('CATEGORY')
      }
    },
    nextStep( nameStep ){
      this.tmpService.step = nameStep
    },
    fnGetPosRecentlyList(key) {
      this.$emit('fnGetPosRecentlyList')
    },
  },
  computed:{
    stepTitle(){
      let text = '';

      if( this.tmpService.step == 'FIRST' ){
        text = 'บริการเสริม'
      }else if( this.tmpService.step == 'CATEGORY' ){
        text = '<i class="fas fa-angle-left pr-1"></i> เลือกผู้ให้บริการ'
      }else if( this.tmpService.step == 'SERVICE' ){
        text = `<i class="fas fa-angle-left pr-1"></i> ${this.tmpService.categoryName}`
      }

      if( this.$THEME.name == 'shippop' ){
        return text + `<small class="px-2"><a  href="https://docs.google.com/presentation/d/1cMq3nXeuROsVIISGOMUcC0t1NL69F0UKdUV_EHAma8A/edit?usp=sharing" target="_blank"> คู่มือการใช้งานบริการเสริม</a></small>`
      }

      return text
    }
  }
}
</script>
